// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__31FKR","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3g344"};